import serverVars from 'server-vars';
import { isBot, BOT_TYPE } from './botTypeHelpers.ts';

export const getIsBotOnClient = (): boolean => isBot(serverVars.get(BOT_TYPE));
